import type { ErrorResponseBody } from "types/api";

export class FetchServerError extends Error {
  request: Request | undefined;
  response: Response | undefined;
  body: ErrorResponseBody | undefined;

  constructor(
    message: string,
    request: Request,
    response: Response,
    body: ErrorResponseBody,
  ) {
    super(message);
    this.name = "FetchServerError";
    if (request) this.request = request;
    if (response) this.response = response;
    if (body) this.body = body;
  }
}
